import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=afa70558"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=afa70558&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports